export class CubeDefinitionData {

    cubeName: string;

    /**
     * List of full qualified dimension attribute names available in the schema e.g. [Date].[year].[year]
     */
    attributes: string[];

    /**
     * Map of attributes to their type (STRING | NUMBER).
     */
    attributeTypes: { [key: string]: string; };

    /**
     * Map of full qualified hierarchy names that map to logical child hierarchies.
     */
    childHierarchies: { [key: string]: string; };

    /**
     * Names of available measures
     */
    measures: string[];

    /**
     * Available start date for the cube
     */
    minAvailableStartDate: string;

    /**
     * Available end date for the cube
     */
    maxAvailableEndDate: string;

    /**
     * Indicates that members from this dimension must be provided as either a filter or on an axis.
     * Multiple members can be added to an axis, but a filter must be only 1
     */
    mandatoryDimension: string;
}
